import React from 'react';

export const NotFound = () => {
    return(
        <div style={{textAlign:'center'}}>
            <br></br>
            <h1>This page could not be found</h1>
        </div>
    )
}